import { Logo } from './Logo';

export function BrandHeader() {
  return (
    <header className="flex items-center gap-2 lg:hidden">
      <Logo className="h-7 w-auto" />
      <span className="text-base font-semibold tracking-tight text-slate-900">
        우리엔
      </span>
    </header>
  );
}
